import { useEffect } from 'react';

//This hook sets the browsers scrollRestore behaviour to manual
//Read more here: https://developer.chrome.com/blog/history-api-scroll-restoration/
function useManualScrollRestore() {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      const previousScrollRestoration = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
      return () => {
        window.history.scrollRestoration = previousScrollRestoration;
      };
    }
  }, []);
}
export default useManualScrollRestore;
